<template>

  <div>
    <!-- <navbar :isCustomer="true" :isCustomerSignedIn="$root.customerData.CustomerSignedIn" ></navbar> -->
    <navbar :isCustomer="true" ></navbar>
      <div id="background">
        <div class="contentArea">
          <h1>Make Your Mobile <br/> as Your Pen</h1>
          <h3>What we do</h3>
          <!-- <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Culpa libero nam natus voluptates inventore nemo quisquam amet, itaque corrupti ratione assumenda eaque modi eos</p> -->
          <p>A single product “DirectSign” is built to make today's sign work easy. You can sign on the document from any place and all the actions will be tracked. Basically, you can make your mobile as your pen. 
The main objective is to verify that it’s the same person that the document is signed and it is secured to confirm the documents are read and signed.  
</p>
          <div class="buttons">
            <b-button rounded outlined class="is-primary" @click="toggleShowSignInModal">Sign In</b-button>
            <b-button rounded outlined class="is-primary" @click="toggleShowSignUpModal">Sign Up</b-button>
          </div>

        </div>

      <div class="modalComponentArea">
          <!-- Select language modal component -->
          <SelectLanguageModal v-if="showLanguageSelectModel" @close="hideSelectLanguageModal"></SelectLanguageModal>

          <!-- Sign in modal component  -->
          <SignInModal v-if="showSignInModal" @close="toggleShowSignInModal" @goToSignUpPage="showSignUpPage"   ></SignInModal>

          <!-- Sign up modal component  -->
          <SignUpModal v-if="showSignUpModal" @close="toggleShowSignUpModal" @successCustomerSignedUp="toggleSubmitNicModal" @goToSignInPage="showSignInPage"></SignUpModal>

          <!-- Submit NIC modal component  -->
          <SubmitNicModal v-if="showSubmitNicModal" :showModal="showSubmitNicModal" @close="toggleSubmitNicModal" @successCustomerNicCapture="toggleUploadSealModal" ></SubmitNicModal>

          <!-- Upload Seal modal component  -->
          <UploadSealModal v-if="showUploadSealModal" @close="toggleUploadSealModal" @successUploadSealImage="showCustomerData"></UploadSealModal>
      </div>

    </div>
  </div>


</template>

<script>
  import Navbar from '@/components/common/Navbar'
  import SelectLanguageModal from '@/components/frontend/SelectLanguageModal'
  import SignUpModal from '@/components/frontend/SignUpModal'
  import SignInModal from '@/components/frontend/SignInModal'
  import SubmitNicModal from '@/components/frontend/SubmitNicModal'
  import UploadSealModal from '@/components/frontend/UploadSealModal'

  export default {
    name:"customer-home",

   components:{
      Navbar,
      SelectLanguageModal,
      SignInModal,
       SignUpModal,
      SubmitNicModal,
      UploadSealModal,
    },

    data(){
      return{
        // isUserSignedIn:false,

        showLanguageSelectModel : true,
        showSignInModal : false,
        showSignUpModal : false,
        showSubmitNicModal : false,
        showUploadSealModal : false, // for dev initially set to true
      }
    },

    methods:{
      hideSelectLanguageModal : function(){
        this.showLanguageSelectModel = false
      },

      toggleShowSignInModal : function(){

        this.showSignInModal = !this.showSignInModal
        console.log("Toggle sign in modal value : "+this.showSignInModal)
      },

        toggleShowSignUpModal: function(){
            this.showSignUpModal = !this.showSignUpModal
            console.log("Toggle sign in modal value : "+this.showSignUpModal)
        },

        showSignUpPage: function(){
          console.log('showSignUpModal')
            this.showSignUpModal = true
            this.showSignInModal = false
        },
        showSignInPage: function(){
          console.log('showSignInModal')
            this.showSignUpModal = false
            this.showSignInModal = true
        },

      toggleSubmitNicModal : function(){
        this.showSignInModal = false
        this.showSubmitNicModal = !this.showSubmitNicModal
      },

      toggleUploadSealModal : function (){
        this.showSubmitNicModal = false
        this.showUploadSealModal = !this.showUploadSealModal
      },


      // use this method to define customer data
      setCustomerData : function(){
        this.$root.customerData = {
            name : "",              // use to store customer name
            // role : 'Lorem ips',     // use to store customer role
            role : 'Customer',     // use to store customer role
            nicNumber:'',           // use to store customer nic number
            email:'',           // use to store customer email
            contactNumber:'',           // use to store customer contact number
            nic_type:'',           // use to store customer nic type
            nicFrontImage : null,   // use to store customer's nic front image
            nicFrontImageURL : null,   // use to store customer's nic front image
            nicBackImage : null,    // use to store customer's nic back image
            nicBackImageURL : null,    // use to store customer's nic back image
            sealImage : null,       // use to store customer's seal or stamp image
            sealImageURL : null,       // use to store customer's seal or stamp image
            CustomerSignedIn:false     //use to store customer signed it or no
        }
      },

      // temp method to show customer inputs
      showCustomerData:function(){

          var component = this

        console.log("====================================")
        console.log("Customer name : "+this.$root.customerData.name)
        console.log("Customer nic : "+this.$root.customerData.nicNumber)
        console.log("Customer role : "+this.$root.customerData.role)
        console.log("Customer nic front image : "+this.$root.customerData.nicFrontImage)
        console.log("Customer nic back image : "+this.$root.customerData.nicBackImage)
        console.log("Customer seal image : "+this.$root.customerData.sealImage)

          var bodyFormData = new FormData();

          bodyFormData.append("name", component.$root.customerData.name);
          bodyFormData.append("email", component.$root.customerData.email);
          bodyFormData.append("nicNumber", component.$root.customerData.nicNumber);
          bodyFormData.append("contactNumber", component.$root.customerData.contactNumber);
          bodyFormData.append("nicFrontImage", component.$root.customerData.nicFrontImage);
          bodyFormData.append("nicBackImage", component.$root.customerData.nicBackImage);
          bodyFormData.append("sealImage", component.$root.customerData.sealImage);

          component.$http({
              method: "post",
              url: component.$base_url+'/customer/register',
              data: bodyFormData,
              headers: { "Content-Type": "multipart/form-data" },
          })
              .then(function (data) {
                  var array =[]
                  array = data.data

                  if(array.success == true){
                      console.log('registered success')
                      // component.isUserSignedIn = true
                      component.$root.customerData.CustomerSignedIn=true
                      component.showUploadSealModal = false
                      component.showSignUpModal = false
                      component.showSubmitNicModal = false
                      component.showUploadSealModal = false
                      component.$router.push({name:'customerDashboard'})
                  }
                  else{

                      component.showUploadSealModal = false
                      component.showSignUpModal = false
                      component.showSubmitNicModal = false
                      component.showUploadSealModal = false
                      component.showSignInModal = true

                      component.$buefy.toast.open({
                          message: array.data.message,
                          type: 'is-danger'
                      })
                  }

              })
              .catch(function (error) {
                  console.log(error)
              });

      },
     

    },

    beforeMount:function(){
      console.log("beforeMount called")

      window.$root = this.$root

      // load initial cutomer data
      this.setCustomerData()

        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        this.$root.invitee_token = urlParams.get('token')

        console.log('customer token - '+this.$root.invitee_token)


    }
  }

</script>

<style>

body, html{
  height: 100%;
}
  .contentArea{

    text-align: left;
    margin-top: 5%;
    margin-left: 5%;

  }

  .contentArea > h1{
    font-size: 60pt;
    font-weight: bold;
    background: -webkit-linear-gradient(#3a8fff 0 30%, #0837ae 55% 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 95px;
  }

  .contentArea > h3{
    font-size: 25pt;
    margin: 30px auto;
    background: -webkit-linear-gradient(#BE9BE8 0 30%, #8D78ED 55% 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

   .contentArea > p{
    width: 50%;
   }

  .contentArea > .buttons{
    margin-top: 25px;
   }

</style>

<style scoped>
#background{
  height: 100%;
  background-image: url("../../assets/images/customer-home-background.png");
  background-size: 45%;
  background-repeat: no-repeat;
  background-position: right;
  position: absolute;
}
</style>
